import { Box, Flex } from "@rebass/grid";
import ListItemSeparator from "@rentiohq/shared-frontend/dist/components/components/ListItemSeparator";
import {
  ETaskMemberType,
  ITask,
} from "@rentiohq/shared-frontend/dist/types/task.types";
import { formatDate } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { appendQueryParams } from "@rentiohq/shared-frontend/dist/utils/url.utils";
import { Button } from "@rentiohq/web-shared/dist/components";
import { useNavigate } from "react-router-dom";
import { TaskMembersWithRole } from "../../../../../../../Tasks/components/TaskDetails/components/TaskMembersWithRole";
import * as S from "./TasksCard.styled";

interface IProps {
  propertyId: number;
  contractId: string;
  tasks: ITask[];
}

export const TasksCard = ({ tasks, propertyId, contractId }: IProps) => {
  const navigate = useNavigate();

  const formatTaskDate = (task: ITask) => {
    const primary = formatDate(task.startDate);
    const secondary = task.executeDate ?? task.dueDate;
    return secondary ? `${primary} (${formatDate(secondary)})` : primary;
  };

  const handleAddTaskClick = () => {
    navigate(
      appendQueryParams({
        path: "/tasks/add",
        queryParams: {
          propertyId,
          contractId,
        },
      }),
    );
  };

  const renderTasks = () => {
    return tasks.map(task => (
      <S.TaskRow key={task.id}>
        <Flex alignItems="flex-start" style={{ gap: 12 }}>
          <Box pt="2px">
            <S.TaskIcon source="task" />
          </Box>
          <Box>
            <S.TaskTitle>{task.title}</S.TaskTitle>
            <S.TaskMeta>
              <TaskMembersWithRole
                members={task.members}
                role={ETaskMemberType.Executor}
                truncateText={false}
              />
            </S.TaskMeta>
            <S.TaskDate>{formatTaskDate(task)}</S.TaskDate>
          </Box>
        </Flex>
        <Button
          appearance="link"
          iconAfterName={"chevronRight"}
          onClick={() => navigate(`/tasks/${task.id}`)}
        >
          {getLocalizedText("location_description.view_task.action")}
        </Button>
      </S.TaskRow>
    ));
  };

  return (
    <Box>
      <S.Header>
        <S.Title size="extraSmall">
          {getLocalizedText("property.related_tasks.label")}
        </S.Title>
        <S.AddTaskBtn onClick={handleAddTaskClick}>
          <span>+</span>
        </S.AddTaskBtn>
      </S.Header>
      <ListItemSeparator />
      <S.Wrapper>{renderTasks()}</S.Wrapper>
    </Box>
  );
};
